export const DEFAULT_VIEWING_MESSAGE = "At HomeGo Removals & Packing Ltd, your security and peace of mind are our top priority. Your complimentary property viewing has been scheduled — there is absolutely no charge for this visit. The crew members below will attend on the date and time confirmed. Every member of our team is DBS-approved, fully insured, identity-verified, and wears official HomeGo uniform. On arrival, each crew member will present their HomeGo Digital ID — you may scan the QR code on their badge to verify them in real time on our official verification portal. Thank you for trusting us with your move.";

export const DEFAULT_CALLBACK_MESSAGE = "Thank you for your interest in HomeGo Removals & Packing Ltd. As requested, we have scheduled a callback for you — one of our friendly moving consultants will call you at the date and time confirmed below. There is no charge and no obligation; we simply want to answer your questions and help you plan a smooth, stress-free move. If the time no longer suits you, just reply to this email or call us and we will happily rearrange.";

export const generatePropertyViewingEmailHTML = (data) => {
  const {
    customer_name = "",
    property_address = "",
    viewing_date = "",
    viewing_time = "",
    customer_mobile = "",
    appointment_type = "viewing",
    trust_message = DEFAULT_VIEWING_MESSAGE,
    crew = [],
    verify_base_url = "",
  } = data;

  const isCallback = appointment_type === "callback";

  const crewHTML = crew.length === 0
    ? `<tr><td style="padding: 20px; text-align: center; color: #9CA3AF; font-size: 13px;">No crew assigned yet.</td></tr>`
    : crew.map((m) => {
        const verifyUrl = `${verify_base_url}/api/verify-crew/${m.id}`;
        const qrUrl = `https://api.qrserver.com/v1/create-qr-code/?size=110x110&bgcolor=FFFFFF&color=000000&data=${encodeURIComponent(verifyUrl)}`;
        return `
        <tr>
          <td style="padding: 8px 0;">
            <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color: #111827; border: 1px solid #D4AF37; border-radius: 12px;">
              <tr>
                <td style="padding: 18px 20px;">
                  <table border="0" cellpadding="0" cellspacing="0" width="100%">
                    <tr>
                      <td style="vertical-align: middle;">
                        <p style="margin: 0 0 3px; font-size: 12px; color: #9CA3AF; letter-spacing: 2px;">HOMEGO DIGITAL ID</p>
                        <p style="margin: 0 0 4px; font-size: 19px; font-weight: bold; color: #FFFFFF;">${m.name}</p>
                        <p style="margin: 0 0 10px; font-size: 13px; color: #D4AF37; font-weight: 600;">${m.role}</p>
                        <span style="display: inline-block; background-color: #22c55e; color: #000000; font-size: 10px; font-weight: bold; padding: 4px 12px; border-radius: 20px; letter-spacing: 1px;">✓ DBS CHECKED</span>
                        <span style="display: inline-block; background-color: #D4AF37; color: #000000; font-size: 10px; font-weight: bold; padding: 4px 12px; border-radius: 20px; letter-spacing: 1px; margin-left: 4px;">✓ VERIFIED</span>
                      </td>
                      <td width="120" align="right" style="vertical-align: middle;">
                        <a href="${verifyUrl}" target="_blank" style="text-decoration: none;">
                          <img src="${qrUrl}" alt="Scan to verify ${m.name}" width="100" height="100" style="display: block; border-radius: 8px; border: 3px solid #FFFFFF;" />
                          <p style="margin: 6px 0 0; font-size: 10px; color: #D4AF37; text-align: center; font-weight: bold;">SCAN TO VERIFY</p>
                        </a>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </td>
        </tr>`;
      }).join("");

  return `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Your Property Viewing Is Arranged</title>
</head>
<body style="margin: 0; padding: 0; background-color: #F3F4F6; font-family: Helvetica, Arial, sans-serif;">
  <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color: #F3F4F6;">
    <tr>
      <td align="center" style="padding: 20px 10px;">
        <table border="0" cellpadding="0" cellspacing="0" width="600" style="max-width: 600px; background-color: #000000; border-radius: 16px; overflow: hidden;">
          
          <!-- Header -->
          <tr>
            <td style="background-color: #000000; padding: 32px 40px 10px; text-align: center;">
              <p style="margin: 0 0 4px; font-size: 12px; color: #D4AF37; letter-spacing: 4px; font-weight: bold;">HOMEGO REMOVALS &amp; PACKING LTD</p>
              <h1 style="margin: 0 0 8px; font-size: 26px; color: #FFFFFF; font-weight: bold;">${isCallback ? "Your Callback Is Scheduled" : "Your Property Viewing Is Arranged"}</h1>
              <span style="display: inline-block; background-color: #22c55e; color: #000000; font-size: 11px; font-weight: bold; padding: 6px 18px; border-radius: 20px; letter-spacing: 1px;">${isCallback ? "FREE CALLBACK · NO OBLIGATION" : "COMPLIMENTARY · NO CHARGE · DBS-VERIFIED CREW"}</span>
            </td>
          </tr>

          <!-- Greeting + Trust Message -->
          <tr>
            <td style="padding: 28px 40px 10px;">
              ${customer_name ? `<p style="margin: 0 0 14px; font-size: 15px; color: #FFFFFF; font-weight: bold;">Dear ${customer_name},</p>` : ""}
              <p style="margin: 0; font-size: 14px; color: #D1D5DB; line-height: 1.7;">${trust_message}</p>
            </td>
          </tr>

          <!-- Viewing Details -->
          <tr>
            <td style="padding: 24px 40px 10px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color: #111827; border: 1px solid #374151; border-radius: 12px;">
                <tr>
                  <td style="padding: 20px;">
                    <p style="margin: 0 0 14px; font-size: 12px; color: #D4AF37; letter-spacing: 3px; font-weight: bold;">${isCallback ? "CALLBACK DETAILS" : "VIEWING DETAILS"}</p>
                    <table border="0" cellpadding="0" cellspacing="0" width="100%">
                      ${isCallback ? `
                      <tr>
                        <td style="padding: 6px 0; font-size: 13px; color: #9CA3AF; width: 130px;">📱 We'll call you on</td>
                        <td style="padding: 6px 0; font-size: 14px; color: #FFFFFF; font-weight: 600;">${customer_mobile || "—"}</td>
                      </tr>
                      ` : `
                      <tr>
                        <td style="padding: 6px 0; font-size: 13px; color: #9CA3AF; width: 130px;">📍 Property</td>
                        <td style="padding: 6px 0; font-size: 14px; color: #FFFFFF; font-weight: 600;">${property_address || "—"}</td>
                      </tr>
                      `}
                      <tr>
                        <td style="padding: 6px 0; font-size: 13px; color: #9CA3AF;">📅 Date</td>
                        <td style="padding: 6px 0; font-size: 14px; color: #FFFFFF; font-weight: 600;">${viewing_date || "—"}</td>
                      </tr>
                      <tr>
                        <td style="padding: 6px 0; font-size: 13px; color: #9CA3AF;">⏰ Time</td>
                        <td style="padding: 6px 0; font-size: 14px; color: #FFFFFF; font-weight: 600;">${viewing_time || "—"}</td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          ${isCallback ? "" : `
          <!-- Assigned Crew -->
          <tr>
            <td style="padding: 24px 40px 10px;">
              <p style="margin: 0 0 12px; font-size: 12px; color: #D4AF37; letter-spacing: 3px; font-weight: bold;">YOUR ASSIGNED CREW</p>
              <table border="0" cellpadding="0" cellspacing="0" width="100%">
                ${crewHTML}
              </table>
            </td>
          </tr>

          <!-- Verify Banner -->
          <tr>
            <td style="padding: 20px 40px 28px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%); border-radius: 12px;">
                <tr>
                  <td style="padding: 16px 20px; text-align: center;">
                    <p style="margin: 0; font-size: 12px; color: #000000; font-weight: bold; letter-spacing: 1px;">🛡️ ASK THE CREW TO SHOW THEIR HOMEGO DIGITAL ID ON ARRIVAL — SCAN THE QR TO VERIFY LIVE.</p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          `}
          ${isCallback ? `
          <!-- Callback Banner -->
          <tr>
            <td style="padding: 20px 40px 28px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%); border-radius: 12px;">
                <tr>
                  <td style="padding: 16px 20px; text-align: center;">
                    <p style="margin: 0; font-size: 12px; color: #000000; font-weight: bold; letter-spacing: 1px;">📞 NEED US SOONER? CALL 07440 414548 ANY TIME — WE'RE HAPPY TO HELP.</p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          ` : ""}

          <!-- Footer -->
          <tr>
            <td style="background-color: #0a0a0a; padding: 20px 40px; text-align: center; border-top: 1px solid #1F2937;">
              <p style="margin: 0 0 4px; font-size: 12px; color: #9CA3AF;">HomeGo Removals &amp; Packing Ltd · Questions? Call <a href="tel:07440414548" style="color: #D4AF37; text-decoration: none; font-weight: bold;">07440 414548</a></p>
              <p style="margin: 0; font-size: 11px; color: #4B5563;">${isCallback ? "This callback is completely free with no obligation." : "This viewing is completely free of charge with no obligation."}</p>
            </td>
          </tr>

        </table>
      </td>
    </tr>
  </table>
</body>
</html>`;
};

export default generatePropertyViewingEmailHTML;
